module.exports = __webpack_public_path__ + "static/media/evolutioncrm.4954405b.svg";